import React, { PropsWithChildren } from 'react';
import { ButtonProps } from 'react-bootstrap';

type Props = ButtonProps & {
  value?: any;
  onClick?: (value: any) => void;
  className?: string;
  role?: React.AriaRole;
  tabIndex?: number;
  selected?: boolean;
  disabled?: boolean;
};

const ControlItem = React.forwardRef<HTMLButtonElement, PropsWithChildren<Props>>(({ children, onClick, value, className, ...rest }, ref) => {
  const clickHandler = () => onClick && onClick(value);
  return (
    <li>
      <button type="button" onClick={clickHandler} className={className} ref={ref} role={rest.role || 'button'} {...rest}>
        {children}
      </button>
    </li>
  );
});

export default ControlItem;
